import React from 'react'
import PropTypes from 'prop-types'

const Plus = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14.85 0.85L16.29 2.29L11.41 7.17L8.12001 3.88C7.73001 3.49 7.10001 3.49 6.71001 3.88L0.710011 9.89C0.320011 10.28 0.320011 10.91 0.710011 11.3C1.10001 11.69 1.73001 11.69 2.12001 11.3L7.41001 6L10.7 9.29C11.09 9.68 11.72 9.68 12.11 9.29L17.7 3.71L19.14 5.15C19.45 5.46 19.99 5.24 19.99 4.8V0.5C20 0.22 19.78 0 19.5 0H15.21C14.76 0 14.54 0.54 14.85 0.85Z'
      fill={color}
    />
  </svg>
)

Plus.defaultProps = {
  color: 'currentColor',
  width: '14',
  height: '14',
}

Plus.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default Plus
